import { generateActionForKey, generateActions } from "../generateActions";
import { NotifyHelper } from "../../../helpers/toast";
import { eChuongTrinhDaoTaoChiTietActionsObj } from "../../action-types/chuong-trinh-dao-tao/IChuongTrinhDaoTaoChiTietActions";

export const chuongTrinhDaoTaoChiTietActions = {
    ...generateActions(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET"),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "LOAD_BY_CTDT_ERROR", (m) => { NotifyHelper.Error(m.data) }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "UPDATE_CONG_THUC_ERROR", (m) => { NotifyHelper.Error(m.data) }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "UPDATE_CONG_THUC_SUCCESS", (m) => { NotifyHelper.Success("Cập nhật công thức điểm thành công") }
    ),
}